export const safeResolve = <T>(fn: Promise<T>): Promise<[undefined, T] | [Error]> => fn
  .then((data) => [ undefined, data ] as [undefined, T])
  .catch((err) => [ err ])
